import script from "./ConfluenceMacroSettingsModalHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfluenceMacroSettingsModalHeader.vue?vue&type=script&setup=true&lang=js"

import "./ConfluenceMacroSettingsModalHeader.vue?vue&type=style&index=0&id=6674a05b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6674a05b"]])

export default __exports__